import isEmpty from 'lodash/isEmpty';
import WixSDK from 'shared/utils/wix-sdk';
import * as WidgetsAPI from 'api/widgets';
import { getCompId } from 'shared/utils/comp-id';
import { VIEW_MODES } from '@wix/wix-vod-constants/dist/common/view-modes';

export const getWidgetId = () =>
  `${WixSDK.Utils.getInstanceId()}-${getCompId()}`;

export const getWidgetSettings = () =>
  WidgetsAPI.getWidgetSettings(getWidgetId());

export const updateWidgetSettings = settings =>
  WidgetsAPI.updateWidgetSettings(getWidgetId(), settings);

const getUpdateEntities = ({
  channelId,
  videoId,
  savedChannelId,
  savedVideoId,
}) => {
  const updateData = {};

  if (channelId && channelId !== savedChannelId) {
    updateData.listId = channelId;
  }

  if (videoId && videoId !== savedVideoId) {
    updateData.listId = channelId;
    updateData.itemId = videoId;
  }

  return updateData;
};

export function updateWidget(settings) {
  return WixSDK.getComponentInfo().then(({ pageId }) => {
    const instanceId = WixSDK.Utils.getInstanceId();
    const compId = getCompId();

    return WidgetsAPI.updateWidget(getWidgetId(), {
      instanceId,
      compId,
      pageId,
      settings,
    });
  });
}

export const updateDeeplink = (channelId, videoId) => {
  if (WixSDK.Utils.getViewMode() !== VIEW_MODES.EDITOR) {
    return;
  }

  return getWidgetSettings()
    .then(response => {
      const savedChannelId = _.get(response, 'data.listId');
      const savedVideoId = _.get(response, 'data.itemId');

      const update = getUpdateEntities({
        channelId,
        videoId,
        savedChannelId,
        savedVideoId,
      });

      if (!isEmpty(update)) {
        return updateWidgetSettings(update);
      }
    })
    .catch(({ status }) => {
      // create widget info in case it's not saved yet
      if (status === 404) {
        const update = getUpdateEntities({ channelId, videoId });

        if (!isEmpty(update)) {
          return updateWidget(getUpdateEntities({ channelId, videoId }));
        }
      }
    });
};
